export var IntelligentPhotoCaptureViewType;
(function (IntelligentPhotoCaptureViewType) {
    IntelligentPhotoCaptureViewType["CAMERA"] = "camera";
    IntelligentPhotoCaptureViewType["COMMENT"] = "comment";
    IntelligentPhotoCaptureViewType["ESTIMATOR_CAMERA"] = "estimatorCamera";
    IntelligentPhotoCaptureViewType["ESTIMATOR_GALLERY"] = "estimatorGallery";
    IntelligentPhotoCaptureViewType["ESTIMATOR_ODOMETER_LICENSE_PLATE_EDIT"] = "estimatorOdometerLicensePlateEdit";
    IntelligentPhotoCaptureViewType["ESTIMATOR_VIN_DECODE"] = "estimatorVinDecode";
    IntelligentPhotoCaptureViewType["IMAGE_OCR"] = "imageocr";
    IntelligentPhotoCaptureViewType["IMAGE_IQA"] = "imageiqa";
    IntelligentPhotoCaptureViewType["LETS_TRY"] = "letsTry";
    IntelligentPhotoCaptureViewType["LOADER"] = "loader";
    IntelligentPhotoCaptureViewType["NONE"] = "none";
    IntelligentPhotoCaptureViewType["PREVIEW"] = "preview";
    IntelligentPhotoCaptureViewType["RETAKE_PAGE"] = "retakeView";
    IntelligentPhotoCaptureViewType["VIN_DECODE"] = "vinDecode";
})(IntelligentPhotoCaptureViewType || (IntelligentPhotoCaptureViewType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureViewType.js.map